import { FC, useState } from 'react';
import { OnboardingLinkPage } from '@/__generated__/graphql.ts';
import { CustomStreamMainDataStep } from '@/components/streams/stream-form/custom-stream-form/custom-stream-main-data-step.tsx';
import { CustomStreamPaidDataStep } from '@/components/streams/stream-form/custom-stream-form/custom-stream-paid-data-step.tsx';
import { CustomStreamTypeStep } from '@/components/streams/stream-form/custom-stream-form/custom-stream-type-step.tsx';
import { StreamFormInputs } from '@/components/streams/stream-form/stream-form.tsx';
import { SetupStripeAccountModalContent } from '@/components/stripe-account/setup-stripe-account-modal-content.tsx';
import {
  StripeAccountStatus,
  useStripeAccountStatus,
} from '@/components/stripe-account/use-stripe-account-status.ts';

interface RegularStreamFormProps {
  step: number;
  setStep: (step: number) => void;
  onClose: () => void;
  initialValues?: StreamFormInputs;
}

export const CustomStreamForm: FC<RegularStreamFormProps> = ({
  step,
  setStep,
  onClose,
  initialValues,
}) => {
  const [hasAcceptedPolicy, setHasAcceptedPolicy] = useState(false);
  const { status } = useStripeAccountStatus();

  const hasInitialValues = !!initialValues;

  return step === 1 ? (
    <CustomStreamTypeStep onNext={() => setStep(2)} />
  ) : step === 2 ? (
    status !== StripeAccountStatus.Configured ? (
      <SetupStripeAccountModalContent
        onClose={onClose}
        stripeAccountStatus={status}
        redirectTo={OnboardingLinkPage.CustomStreams}
      />
    ) : (
      <CustomStreamMainDataStep
        hasInitialValues={hasInitialValues}
        setNextStep={() => setStep(3)}
      />
    )
  ) : step === 3 ? (
    <CustomStreamPaidDataStep
      onBack={() => setStep(2)}
      hasAcceptedPolicy={hasAcceptedPolicy}
      onAcceptPolicy={setHasAcceptedPolicy}
      hasInitialValues={hasInitialValues}
    />
  ) : null;
};
